import { JsonObject, JsonProperty } from 'json2typescript';
import ExamReadyRank from '@/models/entry/ExamReadyRank';

@JsonObject('ExamReadyEntry')
export default class ExamReadyEntry {
  constructor() {
    this.examinationEntryCode = '';
    this.canStartExamination = false;
    this.examRank = new ExamReadyRank();
  }

  @JsonProperty('examination_entry_code')
  public examinationEntryCode: string;

  @JsonProperty('can_start_examination', null, true)
  public canStartExamination: boolean;

  @JsonProperty('exam_rank', ExamReadyRank)
  public examRank: ExamReadyRank;
}
